import { render, staticRenderFns } from "./CustomInputNumber.vue?vue&type=template&id=543b5019"
import script from "./CustomInputNumber.vue?vue&type=script&lang=js"
export * from "./CustomInputNumber.vue?vue&type=script&lang=js"
import style0 from "./CustomInputNumber.vue?vue&type=style&index=0&id=543b5019&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports